export const interiorSpaces = [
  "Dnevni boravak",
  "Spavaća soba",
  "Blagovaonica",
  "Kuhinja",
  "Kupaonica",
  "Dječja soba",
  "Ured",
  "Apartman",
] as const;

export const exteriorSpaces = [
  "Fasada",
  "Terasa",
  "Balkon",
  "Dvorište",
  "Vrt",
  "Ograda",
  "Ulaz",
  "Krov",
] as const;

export const styles = [
  "Moderan",
  "Skandinavski",
  "Mediteranski",
  "Industrijski",
  "Klasičan",
  "Minimalistički",
  "Luksuzan",
  "Povoljan obiteljski",
] as const;

export type ProjectKind = "interior" | "exterior";
export type ProjectStatus = "draft" | "queued" | "processing" | "completed" | "failed" | "expired";
export type ProductCategory =
  | "sofa"
  | "coffee-table"
  | "rug"
  | "tv-unit"
  | "lighting"
  | "garden-set"
  | "fence"
  | "paver"
  | "outdoor-light";

export type ProjectPreferences = {
  style: (typeof styles)[number];
  budgetMin: number;
  budgetMax: number;
  colours: string[];
  keep: string;
  remove: string;
  notes: string;
  wallWidthCm?: number;
};

export type Project = {
  id: string;
  kind: ProjectKind;
  space: string;
  status: ProjectStatus;
  preferences: ProjectPreferences;
  originalImageUrl?: string;
  createdAt: string;
  expiresAt: string;
  failureMessage?: string;
  backend?: "local" | "worker";
};

export type DetectedElement = {
  id: string;
  category: ProductCategory;
  label: string;
  colourTags: string[];
  styleTags: string[];
  materialTags: string[];
  featureTags: string[];
  widthCm?: number;
  budgetCents?: number;
};

export type DesignVariant = {
  id: string;
  projectId: string;
  title: string;
  explanation: string;
  style: string;
  estimatedMinCents: number;
  estimatedMaxCents: number;
  imageUrl: string;
  detectedElements: DetectedElement[];
  productCount: number;
};

export type Product = {
  id: string;
  demo: boolean;
  store: string;
  title: string;
  category: ProductCategory;
  priceCents: number;
  previousPriceCents?: number;
  currency: "EUR";
  productUrl: string;
  affiliateUrl?: string;
  imageUrl: string;
  widthCm?: number;
  depthCm?: number;
  heightCm?: number;
  colourTags: string[];
  styleTags: string[];
  materialTags: string[];
  featureTags: string[];
  active: boolean;
  checkedAt: string;
};

export type ProductMatch = {
  product: Product;
  score: number;
  level: "Vrlo slično" | "Slično" | "Inspirirano";
  explanation: string[];
};
